import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { ChannelDetailsSection, ControlPanelSection, MessagesSection } from 'components/organisms/Chat';
import { PageContext } from 'pages/Chat/PageProvider';
import { Container, Divider, Stack } from 'shell/components';

const Desktop = () => {
    const {
        activeGroupId,
        setActiveGroupId,
        channels,
        setChannels,
        directs,
        latestMessages,
        setLatestMessages,
        activeChatId,
        setActiveChatId,
        messages,
        setMessages,
        files,
        setFiles,
        deleteMessage,
        setCreateChannelDialog,
        setEditChannelDialog,
        setManageMembersDialog,
        setAlertDialog,
        search,
        setSearch,
        channelDetailsOpen,
        setChannelDetailsOpen,
    } = useContext(PageContext);

    return (
        <Container device={'desktop'}>
            <CustomStack direction={'row'} divider={<Divider flexItem orientation={'vertical'} />}>
                <ControlPanelSection
                    activeGroupId={activeGroupId}
                    setActiveGroupId={setActiveGroupId}
                    channels={channels}
                    directs={directs}
                    latestMessages={latestMessages}
                    activeChatId={activeChatId}
                    setActiveChatId={setActiveChatId}
                    setCreateChannelDialog={setCreateChannelDialog}
                    search={search}
                    setSearch={setSearch}
                />
                <MessagesSection
                    activeGroupId={activeGroupId}
                    channels={channels}
                    directs={directs}
                    setLatestMessages={setLatestMessages}
                    activeChatId={activeChatId}
                    messages={messages}
                    setMessages={setMessages}
                    setFiles={setFiles}
                    deleteMessage={deleteMessage}
                    setAlertDialog={setAlertDialog}
                    channelDetailsOpen={channelDetailsOpen}
                    setChannelDetailsOpen={setChannelDetailsOpen}
                />
                {channelDetailsOpen ? (
                    <ChannelDetailsSection
                        activeGroupId={activeGroupId}
                        channels={channels}
                        setChannels={setChannels}
                        directs={directs}
                        activeChatId={activeChatId}
                        setActiveChatId={setActiveChatId}
                        files={files}
                        setEditChannelDialog={setEditChannelDialog}
                        setManageMembersDialog={setManageMembersDialog}
                        setAlertDialog={setAlertDialog}
                    />
                ) : null}
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        borderRadius: '12px 12px 0 0',
        width: '100%',
        minHeight: 'calc(100vh - 64px - 20px)',
        background: theme.palette.ensightful.shades[0],
    };
});

export default Desktop;
